module.exports = __webpack_public_path__ + "admin.jpg?5fd1d4e98e6701e94f713044b14ab6be";


//////////////////
// WEBPACK FOOTER
// ./src/images/admin.jpg
// module id = 447
// module chunks = 27